export type ResumeOptions = {
  [key: string]: string
}

export const DEFAULT_RESUME_OPTIONS: ResumeOptions = {
  language: "en"
}